module.exports = __webpack_public_path__ + "static/show-tv-min-43f07d4aa2d1379daffaabb083ca65dd.png";